import { AdministrationGroupFaculty, StudyFaculty } from '../../../../types';

const RES_FACULTY = {
  1: 'Representación ante instituciones',
  2: 'Representación ante sociedades y asociaciones',
  3: 'Celebración de contratos',
  4: 'Constitución de garantías',
  5: 'Contratos de trabajo',
  6: 'Constitución de sociedades',
  7: 'Operaciones con cheques, letras, pagarés y otros documentos mercantiles',
  8: 'Cobrar y percibir',
  9: 'Operaciones con bancos e instituciones financieras',
  10: 'Créditos',
  11: 'Derivados',
  12: 'Seguros',
  13: 'Registro de marcas',
  14: 'Operaciones de comercio exterior',
  15: 'Pagos y extinción de obligaciones',
  16: 'Firma de documentos y retiro de correspondencia',
  17: 'Mandatos',
  18: 'Representación judicial',
  19: 'Autocontratación',
};

const UNKNOWN_FACULTY_MESSAGE = 'Facultad desconocida';

export const studyFacultiesToGroupFaculties = (
  faculties: StudyFaculty[],
): AdministrationGroupFaculty[] => {
  return faculties.map((faculty) => ({
    facultyId: faculty.faculty,
    message: RES_FACULTY[faculty.faculty] || UNKNOWN_FACULTY_MESSAGE,
    restriction: [],
  }));
};
